export class composeMessageUrl  {
   sendMessage = "sse/v1/message/send/";
}